/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const startupTierRowDtoSchema = z.object({
  tier: z.optional(z.string()),
  numberOfStartups: z.optional(z.string()),
  estValue: z.optional(z.string()),
  regionalBreakdown: z.string().nullish(),
});
